@if (editMode) {
  <div>
    <div
      class="upload-edit-control"
      (click)="onEditClick()"
  style="
    margin: 4px;
    border: 3px dashed var(--neutral-color-400);
    background-color: var(--neutral-color-100);
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 100px;
  ">
      <div style="margin-right: 0.5rem">
        <i
          class="icon icon-text"
        style="font-size: 24px"></i>
      </div>
      <div>{{ 'COMMUNICATIONS.DESIGNER.ELEMENTS.TEXT-EDIT' | translate }}</div>
    </div>
  </div>
}
@if (!editMode) {
  <div>
    <quill-view [content]="richTextOrPlaceHolder" format="html"></quill-view>
  </div>
}
@if (showRichText) {
  <topo-rich-text-edit
    [isActive]="showRichText"
    title="{{ 'MANAGEMENT.COMMUNICATION-CENTER.MODIFY-RICH-TEXT' | translate }}"
    [value]="richTextValue"
    [backgroundCanClose]="false"
    (richTextUpdated)="updateRichText($event)"
    (cancelRichText)="cancelRichText()"
    [enableMentions]="true"
  [mentionSearch]="getUserList.bind(this)"></topo-rich-text-edit>
}

